import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Icon, Button } from "semantic-ui-react";
import { toast } from "react-toastify";
import moment from "moment";
import _ from "lodash";
import cx from "classnames";
import {
  fetchInvitations,
  resendInvitation,
  deleteInvitation,
} from "actions/invitations";
import styles from "./invitations.module.scss";
import InfiniteScroll from "components/ui/InfiniteScroll";
import { isAccountSuspended } from "components/features/Util/Util";


const initInvitationFilters = {
  page: 0,
  limit: 10,
  query: "",
  type: "PENDING",
  sort: "invited_date",
  order: "ASC",
  refresh: true,
};

export default function Invitations({
  account,
  query,
  sort,
  order,
  setTotal,
  setLoading,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);

  const [filters, setFilters] = useState(initInvitationFilters);
  const [initialRender, setInitialRender] = useState(true);

  const invitations = useSelector((state) => _.get(state, "invitations.items"));
  const loading = useSelector((state) => _.get(state, "invitations.loading"));
  const currentPage = useSelector((state) =>
    _.get(state, "invitations.pagination.currentPage")
  );
 
  const totalPages = useSelector((state) =>
    _.get(state, "invitations.pagination.totalPages")
  );

  const totalRecordsCount = useSelector((state) =>
    _.get(state, "invitations.pagination.totalRecordsCount")
  );

  const resendingInvitation = useSelector((state) =>
    _.get(state, "invitations.resendingInvitation")
  );

  const deletingInvitation = useSelector((state) =>
    _.get(state, "invitations.deletingInvitation")
  );

  const permissionData = useSelector((state) => _.get(state, "users.me.role"));

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (query) {
      query = query.trim();
    }

    setPage(0);
    setFilters({ ...filters, query: query, refresh: true });
  }, [query]);

  useEffect(() => {
    setFilters({ ...filters,refresh: false });
  }, [page]);

  useEffect(() => {
    setTotal(totalRecordsCount);
  }, [totalRecordsCount]);

  useEffect(() => {
    if (!initialRender && resendingInvitation) {
      if (!resendingInvitation.resending && resendingInvitation.success) {
        toast.success("Resend invitation successfully");
      }
    }
  }, [resendingInvitation]);

  useEffect(() => {
    if (!initialRender && deletingInvitation) {
      if (!deletingInvitation.deleting && deletingInvitation.success) {
        setFilters({ ...filters, refresh: false });
        toast.success("Deleted invitation successfully");
      }
    }
  }, [deletingInvitation]);

  useEffect(() => {
    setPage(0);
    setFilters({ ...filters, sort: sort, refresh: false });
  }, [sort]);

  useEffect(() => {
    setPage(0);
    setFilters({ ...filters, order: order, refresh: false });
  }, [order]);

  useEffect(() => {
    if (!loading && initialRender) {
      setFilters({ ...filters });
    }
  }, [account]);

  useEffect(() => {
    if (!loading && account) {
      if (query) {
        query = query.trim();
      }

      dispatch(
        fetchInvitations({
          page: page,
          limit: limit,
          filters: { ...filters, account: account.id, query: query },
        })
      );
    }
  }, [filters]);

  setTimeout(() => {
    setInitialRender(false);
  }, [3000]);

  const onResendInvitation = (id) => {
    dispatch(resendInvitation({ id }));
  };

  const onDeleteInvitation = (id) => {
    dispatch(deleteInvitation({ id }));
  };

  console.log(currentPage);

  return (
    <>
      <InfiniteScroll
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        pagination={true}
        setPage={setPage}
      >
        <Table singleLine className={cx(styles.table)}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={4} className={cx(styles.header)}>
                EMAIL
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                ROLE
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                INVITED DATE 
              </Table.HeaderCell>
              <Table.HeaderCell
                width={6}
                className={cx(styles.header)}
              ></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body className={cx(styles.body)}>
            {!loading && invitations.length === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>No Invitations</div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}

            {loading && invitations.length === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>
                      Loading
                      <Icon name="sync" loading className={cx(styles.icon)} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}

            {invitations.length !== 0 && (
              <>
                {invitations.map((item, idx) => (
                  <>
                    <Table.Row key={idx}>
                      <Table.Cell width={4} className={cx(styles.cell)}>
                        <div
                          className={cx(
                            styles.text,
                            styles.ml13,
                            styles.pointer
                          )}
                        >
                          {item.email}
                        </div>
                      </Table.Cell>
                      <Table.Cell width={3} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}>
                          {item && item.roles ? item.roles[0].name : ""}
                        </div>
                      </Table.Cell>
                      <Table.Cell
                        width={3}
                        className={cx(styles.cell)}
                        textAlign="center"
                      >
                        {moment.utc(item.invitedDate).format("YYYY-MMM-DD")}
                      </Table.Cell>
                      <Table.Cell
                        width={6}
                        className={cx(styles.cell)}
                        textAlign="center"
                      >
                        <Button
                          content="Resend"
                          onClick={() => onResendInvitation(item.id)}
                          className={cx(styles.btn, styles.resend)}
                          disabled={isAccountSuspended(account) || !permissionData.invitation.resend}
                        />

                        <Button
                          content="Delete"
                          onClick={() => onDeleteInvitation(item.id)}
                          className={cx(styles.btn, styles.delete)}
                          disabled={isAccountSuspended(account) || !permissionData.invitation.delete}
                        />
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))}
              </>
            )}
          </Table.Body>
        </Table>
      </InfiniteScroll>
    </>
  );
}
